import { sendEvent } from './sendEvent'

export function paidEvent(planType: string, billingCycle: string) {
  sendEvent('event', 'paid', {
    plan_type: planType,
    billing_cycle: billingCycle
  })
}
